module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/sp-cover-1-bc47b676237746fba4a7c2ff34a5bdd9.webp";